var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-section"},[_c('h1',{staticClass:"text-center text-warning"},[_vm._v("404")]),_c('h2',[_vm._v("Not found")])])
}]

export { render, staticRenderFns }